module.exports = __webpack_public_path__ + "static/media/app.c63ba0b1.png";